/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { reposUpdate } from "../../funcs/reposUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PatchRepoRequest$inboundSchema,
};

export const tool$reposUpdate: ToolDefinition<typeof args> = {
  name: "repos-update",
  description: `Update a repository's labels

Applies a label-only update (name/description); org owner/admin only.
The repository id is stable, so a rename is a one-row DB update — no
Gitea write. Omitted fields are left unchanged.
`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await reposUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
